"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemResponseStatus = void 0;
exports.getItemResponseStatuses = getItemResponseStatuses;
exports.getItemResponseStatusFrom = getItemResponseStatusFrom;
var ItemResponseStatus;
(function (ItemResponseStatus) {
    ItemResponseStatus["Correct"] = "correct";
    ItemResponseStatus["PartiallyCorrect"] = "partially_correct";
    ItemResponseStatus["Incorrect"] = "incorrect";
    ItemResponseStatus["NotScored"] = "not_scored";
})(ItemResponseStatus || (exports.ItemResponseStatus = ItemResponseStatus = {}));
function getItemResponseStatuses() {
    return [
        ItemResponseStatus.Correct,
        ItemResponseStatus.PartiallyCorrect,
        ItemResponseStatus.Incorrect,
        ItemResponseStatus.NotScored,
    ];
}
function getItemResponseStatusFrom(value) {
    return getItemResponseStatuses().find(function (type) { return type === value; });
}
